import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import Loader from "./Loader";
const Fortest2 = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  const Textstyle = {
    fontSize: "22px",
    lineHeight: "28px",
    fontWeight: "500",
    color: "#222c5a",
  };
  const StyledHeading = styled.h6`
    position: relative;
    font-size: 100px;
    color: #008bcd;

    &::before {
      content: "—";
      font-size: inherit;
      color: #008bcd;
      display: block;
    }
  `;

  return (
    <div>
    {/**
     <div>
        <Header />
      </div>
     */}
     
      <Loader isVisible={isVisible} />
  
<section className="white-bg page-section-ptb">
  <div className="container">
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 text-center">
        <div className="isotope-filters">
          <button data-filter="*" className="active">All</button>
          <button data-filter=".photography">photography</button>
          <button data-filter=".illustration">illustration</button>
          <button data-filter=".branding">branding</button>
          <button data-filter=".web-design1">web-design1</button>
        </div>
        <div className="isotope columns-2 popup-gallery">
          <div className="grid-item photography branding">
            <div className="portfolio-item">
              <img src="/assets/images//RSE/SDG4.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG4.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item photography branding">
            <div className="portfolio-item">
              <img src="/assets/images//RSE/SDG5.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG5.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item illustration">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG6.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG6.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item illustration">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG7.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG7.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item branding illustration">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG8.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG8.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item branding illustration">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG9.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG9.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item web-design1 photography">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG10.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG10.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item web-design1 photography">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG11.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG11.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item web-design12 photography">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG12.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG12.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item web-design12 photography">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG13.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG13.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item web-design12 photography">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG16.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG16.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
          <div className="grid-item web-design12 photography">
            <div className="portfolio-item">
              <img src="/assets/images/RSE/SDG17.png" alt />
              <div className="portfolio-overlay">
                <h4 className="text-white"> <a href="portfolio-single-01.html"> Your title here </a> </h4>
                <span className="text-white"> <a href="#"> Branding </a> | <a href="#"> Web Design </a> </span> 
              </div>
              <a className="popup portfolio-img" href="/assets/images/RSE/SDG17.png"><i className="fa fa-arrows-alt" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</section>


    </div>
  );
};
export default Fortest2;
